import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Sydney" />

        <footer className="footer">
          This project was coded by Renee Singh and is open-sourced on{" "}
          <a
            href="https://github.com/renxss/react-weather-forecast"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
          </a>
        </footer>
      </div>
    </div>
  );
}
